import { render, staticRenderFns } from "./LabelPicker.vue?vue&type=template&id=23154a61&scoped=true"
import script from "./LabelPicker.vue?vue&type=script&lang=ts"
export * from "./LabelPicker.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./LabelPicker.vue?vue&type=style&index=1&id=23154a61&prod&lang=scss"
import style2 from "./LabelPicker.vue?vue&type=style&index=2&id=23154a61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23154a61",
  null
  
)

export default component.exports